import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { PaymentProvider } from '@savgroup-front-common/types/Payment/PaymentProvider';

const ENDPOINT = `${APIConfiguration.payment}payment/session/${COMMON_QUERY_PARAMS.SESSION_ID}`;

export enum Kind {
  CLAIM_GROUP = 'ClaimGroup',
  FILE = 'File',
}

interface GetFileLastPaymentQueryArgs {
  kindId: string;
  sessionId: string;
  kind: Kind;
}

export interface PaymentSessionSummaryDto {
  sessionId: string;
  paymentProvider: PaymentProvider;
  statusCode: string;
  isPaymentValid: boolean;
  isPaymentInProgress: boolean;
}

export async function getPaymentSessionQuery(
  payload: GetFileLastPaymentQueryArgs,
): Promise<BackResponse<PaymentSessionSummaryDto> | BackResponseFailure> {
  try {
    const url = ENDPOINT.replace(
      COMMON_QUERY_PARAMS.SESSION_ID,
      payload.sessionId,
    );

    return await apiCall<BackResponse<PaymentSessionSummaryDto>>(
      buildUrl(url, {
        kindId: payload.kindId,
        kind: payload.kind,
      }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
